function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import DealsLayout from "../DealsLayout/newIndex";
// import { Splide, SplideSlide } from "@splidejs/react-splide";
// import "@splidejs/splide/dist/css/themes/splide-default.min.css";
// import Grid from "@splidejs/splide-extension-grid";
import { giftSvg } from "../../svg";
import { toast } from "react-toastify";
import ReactGA from "react-ga4";
import TiTick from "@meronex/icons/ti/TiTick";
import GrClose from "@meronex/icons/gr/GrClose";
import PhoneNumber from "../PhoneNumber";
import Modal from "../../../Common/Modal";
import AiOutlineLeft from "@meronex/icons/ai/AiOutlineLeft";
import AiOutlineRight from "@meronex/icons/ai/AiOutlineRight";
import { BundleSvg } from "./svg";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function BundleOffers(_ref) {
  var _redux$userId, _redux$auth, _redux$userMobile, _redux$userDetails, _redux$clientWebview, _redux$webView, _redux$internalWebvie, _redux$webView2, _bundleOffers$, _config$deals, _bundleOffers$2, _config$deals2, _config$sectionBackgr, _config$deals3, _bundleOffers$3, _config$deals4;
  var bundleOffers = _ref.bundleOffers,
    config = _ref.config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showModal = _useState4[0],
    setShowModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    bundleLoading = _useState6[0],
    setBundleLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    bundleDealDetails = _useState8[0],
    setBundleDealDetails = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    captureUserMobile = _useState0[0],
    setCaptureUserMobile = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    bundleDealModal = _useState10[0],
    setBundleDealModal = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedOffers = _useState12[0],
    setSelectedOffers = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    previousSelectedOffers = _useState14[0],
    setPreviousSelectedOffers = _useState14[1];
  var isAuthenticated = redux === null || redux === void 0 ? void 0 : redux.isAuthenticated;
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var authActions = redux === null || redux === void 0 ? void 0 : redux.authActions;
  var userId = (_redux$userId = redux === null || redux === void 0 ? void 0 : redux.userId) !== null && _redux$userId !== void 0 ? _redux$userId : redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.userId;
  var userMobile = (_redux$userMobile = redux === null || redux === void 0 ? void 0 : redux.userMobile) !== null && _redux$userMobile !== void 0 ? _redux$userMobile : redux === null || redux === void 0 || (_redux$userDetails = redux.userDetails) === null || _redux$userDetails === void 0 ? void 0 : _redux$userDetails.mobileNumber;
  var clientWebview = (_redux$clientWebview = redux === null || redux === void 0 ? void 0 : redux.clientWebview) !== null && _redux$clientWebview !== void 0 ? _redux$clientWebview : redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.clientWebview;
  var internalWebview = (_redux$internalWebvie = redux === null || redux === void 0 ? void 0 : redux.internalWebview) !== null && _redux$internalWebvie !== void 0 ? _redux$internalWebvie : redux === null || redux === void 0 || (_redux$webView2 = redux.webView) === null || _redux$webView2 === void 0 ? void 0 : _redux$webView2.internalWebview;
  // console.log('bundleOffers', bundleOffers);
  // console.log('bundleOffers', bundleOffers);
  var clickThroughMobile = clientWebview || internalWebview;
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {}
  };
  var location = (router === null || router === void 0 ? void 0 : router.location) || {
    search: ""
  };
  var queryParams = new URLSearchParams(location.search);
  var channel = queryParams.get("utm_medium");
  var handleCheckboxChange = function handleCheckboxChange(offer) {
    // console.log("bundleOffer from deal&Discount" , offer );
    setSelectedOffers(function (prevSelected) {
      var isSelected = prevSelected === null || prevSelected === void 0 ? void 0 : prevSelected.some(function (item) {
        return item.id === offer.id;
      });
      if (isSelected) {
        return prevSelected === null || prevSelected === void 0 ? void 0 : prevSelected.filter(function (item) {
          return item.id !== offer.id;
        });
      } else {
        return [].concat(_toConsumableArray(prevSelected), [offer]);
      }
    });
  };

  // console.log('SelectedBundle Offers', selectedOffers);
  // console.log('selectedDea;Details', bundleDealDetails);

  var redeemSelectedDeals = function redeemSelectedDeals(mobile) {
    // setBundleDealDetails([]);
    // setShowModal(false);

    if (!isAuthenticated) {
      if (dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal) {
        dispatch(authActions.openLoginModal());
      }
      return;
    }
    if (!userMobile && !mobile) {
      setCaptureUserMobile(true);
      setShowModal(true);
      return;
    }
    setBundleLoading(true);
    // const selectedOffersIds = selectedOffers.map((offer) => offer.dealId);
    var selectedOffersIds = selectedOffers.map(function (offer) {
      return offer.id;
    });
    // console.log('selectedOffersIds', selectedOffersIds);
    var apiCall = Promise.all(selectedOffersIds === null || selectedOffersIds === void 0 ? void 0 : selectedOffersIds.map(function (id) {
      return winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
        method: "GET",
        url: "/winnre/user/deals/".concat(id)
      });
    }));
    setBundleLoading(true);
    apiCall.then(function (res) {
      setBundleDealModal(false);
      setBundleDealDetails(res);
      setShowModal(true);
      setBundleLoading(false);
      setPreviousSelectedOffers(_toConsumableArray(selectedOffers));
      setSelectedOffers([]);
      previousSelectedOffers === null || previousSelectedOffers === void 0 || previousSelectedOffers.forEach(function (offer) {
        var _window, _offer$tags;
        (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("RedeemSelectedDealClicked", {
          DealId: "".concat(offer === null || offer === void 0 ? void 0 : offer.id),
          BrandName: "".concat(offer === null || offer === void 0 ? void 0 : offer.vendorName),
          Category: "".concat(offer === null || offer === void 0 ? void 0 : offer.categoryName),
          // Tags: `${offer?.Tags}`
          Tags: "".concat(offer === null || offer === void 0 || (_offer$tags = offer.tags) === null || _offer$tags === void 0 ? void 0 : _offer$tags.map(function (tag) {
            return tag === null || tag === void 0 ? void 0 : tag.name;
          }))
        });
      });
    })["catch"](function (err) {
      toast.error("Something Went Wrong");
      setBundleLoading(false);
    });
  };
  var redeemAllClicked = function redeemAllClicked(mobile) {
    // setBundleDealDetails([]);
    // setShowModal(false);

    if (!isAuthenticated) {
      if (dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal) {
        dispatch(authActions.openLoginModal());
      }
      return;
    }
    console.log({
      userMobile: userMobile
    });
    if (!userMobile && !mobile) {
      setCaptureUserMobile(true);
      setShowModal(true);
      return;
    }
    setBundleLoading(true);
    var bundleIds = bundleOffers.map(function (offer) {
      return offer.id;
    });
    console.log(bundleIds);
    var apiCall = Promise.all(bundleIds === null || bundleIds === void 0 ? void 0 : bundleIds.map(function (id) {
      return winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
        method: "GET",
        url: "/winnre/user/deals/".concat(id)
      });
    }));
    setBundleLoading(true);
    apiCall.then(function (res) {
      console.log("redeem All Clicked", res);
      setBundleDealDetails(res);
      setShowModal(true);
      setBundleLoading(false);
      var _iterator = _createForOfIteratorHelper(bundleOffers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _window2, _bundleDeal$tags;
          var bundleDeal = _step.value;
          (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("RedeemAllClicked", {
            DealId: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.id),
            BrandName: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.vendorName),
            Tags: "".concat(bundleDeal === null || bundleDeal === void 0 || (_bundleDeal$tags = bundleDeal.tags) === null || _bundleDeal$tags === void 0 ? void 0 : _bundleDeal$tags.map(function (tag) {
              return tag === null || tag === void 0 ? void 0 : tag.name;
            }))
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    })["catch"](function (err) {
      toast.error("Something Went Wrong");
      setBundleLoading(false);
    });
  };
  useEffect(function () {
    if (!showModal) {
      setStep(0);
    }
  }, [showModal]);
  console.log("selectedDealDetails", bundleDealDetails);
  var redeemAllBundleOffers = function redeemAllBundleOffers() {
    var _cmsClient$defaults, _cmsClient$defaults2;
    if ((cmsClient === null || cmsClient === void 0 || (_cmsClient$defaults = cmsClient.defaults) === null || _cmsClient$defaults === void 0 ? void 0 : _cmsClient$defaults.baseURL) === "https://prod.loyalie.in" || (cmsClient === null || cmsClient === void 0 || (_cmsClient$defaults2 = cmsClient.defaults) === null || _cmsClient$defaults2 === void 0 ? void 0 : _cmsClient$defaults2.baseURL) === "https://uat.loyalie.in") {
      // window.fbq("trackCustom", "RedeemNowButtonClicked"); redo
    }
    ReactGA.event({
      category: "OFFER",
      action: "REDEEM NOW CLICKED",
      label: "REDEEM OFFER BUTTON"
    });
    var dealsToMap = (previousSelectedOffers === null || previousSelectedOffers === void 0 ? void 0 : previousSelectedOffers.length) > 0 ? previousSelectedOffers : bundleOffers;
    var processDeals = function processDeals(deals, res) {
      var index = 0;
      var offers = bundleDealDetails;
      var _iterator2 = _createForOfIteratorHelper(deals),
        _step2;
      try {
        var _loop = function _loop() {
          var _window3, _deal$tags, _res$index, _res$index2, _res$index3, _res$index4, _res$index5, _res$index6, _res$index7, _res$index8, _res$index9, _res$index0, _res$index1, _res$index10, _res$index11, _res$index12, _res$index13, _res$index14, _res$index15, _res$index16;
          var deal = _step2.value;
          (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.webengage) === null || _window3 === void 0 || _window3.track("DealClicked", _objectSpread(_objectSpread({
            OfferName: "".concat(deal === null || deal === void 0 ? void 0 : deal.title),
            RedemptionType: "".concat(deal === null || deal === void 0 ? void 0 : deal.redemptionType),
            CashbackPercentage: "".concat(deal === null || deal === void 0 ? void 0 : deal.eligibleCashback),
            CouponCode: "".concat(deal === null || deal === void 0 ? void 0 : deal.dealRedemptionCode),
            Category: "".concat(deal === null || deal === void 0 ? void 0 : deal.categoryName),
            Vendor: "".concat(deal === null || deal === void 0 ? void 0 : deal.vendorName),
            Link: "".concat(deal === null || deal === void 0 ? void 0 : deal.url),
            EndDate: "".concat(deal === null || deal === void 0 ? void 0 : deal.endDate),
            Tags: "".concat(deal === null || deal === void 0 || (_deal$tags = deal.tags) === null || _deal$tags === void 0 ? void 0 : _deal$tags.map(function (tag) {
              return tag === null || tag === void 0 ? void 0 : tag.name;
            })),
            DealId: "".concat(deal === null || deal === void 0 ? void 0 : deal.id),
            VoucherCode: deal.dealType === "OFFLINE" ? "" : (deal === null || deal === void 0 ? void 0 : deal.redemptionType) === "VOUCHER" && ((_res$index = res[index]) === null || _res$index === void 0 ? void 0 : _res$index.status) === "SUCCESS" ? (_res$index2 = res[index]) === null || _res$index2 === void 0 ? void 0 : _res$index2.dealCode : ((_res$index3 = res[index]) === null || _res$index3 === void 0 ? void 0 : _res$index3.status) === "FAILED" && (_res$index4 = res[index]) !== null && _res$index4 !== void 0 && _res$index4.message.includes("Repeat:") ? (_res$index5 = res[index]) === null || _res$index5 === void 0 ? void 0 : _res$index5.message.split("Repeat:")[1] : ""
          }, deal.redemptionType === "VOUCHER" && deal.dealType === "OFFLINE" && {
            QRCode: ((_res$index6 = res[index]) === null || _res$index6 === void 0 ? void 0 : _res$index6.status) === "SUCCESS" ? (_res$index7 = res[index]) === null || _res$index7 === void 0 ? void 0 : _res$index7.dealQRCodeLink : ((_res$index8 = res[index]) === null || _res$index8 === void 0 ? void 0 : _res$index8.status) === "FAILED" ? (_res$index9 = res[index]) === null || _res$index9 === void 0 ? void 0 : _res$index9.message.split("Repeat:")[1] : ""
          }), {}, {
            Channel: channel ? channel : "Direct"
          }));
          var offersIndex = offers.findIndex(function (o) {
            return o.id === (deal === null || deal === void 0 ? void 0 : deal.id);
          });
          offers[offersIndex] = _objectSpread(_objectSpread(_objectSpread({}, offers[offersIndex]), deal), {}, {
            VoucherCode: deal.dealType === "OFFLINE" ? "" : (deal === null || deal === void 0 ? void 0 : deal.redemptionType) === "VOUCHER" && ((_res$index0 = res[index]) === null || _res$index0 === void 0 ? void 0 : _res$index0.status) === "SUCCESS" ? (_res$index1 = res[index]) === null || _res$index1 === void 0 ? void 0 : _res$index1.dealCode : ((_res$index10 = res[index]) === null || _res$index10 === void 0 ? void 0 : _res$index10.status) === "FAILED" && (_res$index11 = res[index]) !== null && _res$index11 !== void 0 && _res$index11.message.includes("Repeat:") ? (_res$index12 = res[index]) === null || _res$index12 === void 0 ? void 0 : _res$index12.message.split("Repeat:")[1] : ""
          }, deal.redemptionType === "VOUCHER" && deal.dealType === "OFFLINE" && {
            QRCode: ((_res$index13 = res[index]) === null || _res$index13 === void 0 ? void 0 : _res$index13.status) === "SUCCESS" ? (_res$index14 = res[index]) === null || _res$index14 === void 0 ? void 0 : _res$index14.dealQRCodeLink : ((_res$index15 = res[index]) === null || _res$index15 === void 0 ? void 0 : _res$index15.status) === "FAILED" ? (_res$index16 = res[index]) === null || _res$index16 === void 0 ? void 0 : _res$index16.message.split("Repeat:")[1] : ""
          });
          index++;
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return offers;
    };
    setBundleLoading(true);
    Promise.all(dealsToMap === null || dealsToMap === void 0 ? void 0 : dealsToMap.map(function (deal) {
      return winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
        method: "POST",
        url: "winnre/user/deals/redeem-v2?dealId=".concat((previousSelectedOffers === null || previousSelectedOffers === void 0 ? void 0 : previousSelectedOffers.length) > 0 ? deal === null || deal === void 0 ? void 0 : deal.id : deal === null || deal === void 0 ? void 0 : deal.id, "&sourcePlatform=").concat(clickThroughMobile ? "MOBILE" : "WEBSITE").concat(channel ? "&channel=".concat(channel) : "")
      });
    })).then(function (res) {
      var _window4;
      var updatedOffers = processDeals(dealsToMap, res);
      var otherBundleOffers = bundleOffers.filter(function (offer) {
        return !bundleDealDetails.some(function (deal) {
          return deal.id === offer.id;
        });
      });
      history.push({
        pathname: "/bundleDetails",
        state: {
          offers: updatedOffers,
          filteredOffers: otherBundleOffers
        }
      });
      (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.webengage) === null || _window4 === void 0 || _window4.track("PdfViewed");
      setBundleLoading(false);
    })["catch"](function (err) {
      setBundleLoading(false);
      toast.error("Something Went Wrong");
    });
  };
  var handleViewAllBundleDeal = function handleViewAllBundleDeal() {
    history.push("dealListing?categoryID=8&categoryName=Bundle");
    return;
  };
  console.log("bundleOffers[0].tags[0].name", (_bundleOffers$ = bundleOffers[0]) === null || _bundleOffers$ === void 0 || (_bundleOffers$ = _bundleOffers$.tags[0]) === null || _bundleOffers$ === void 0 ? void 0 : _bundleOffers$.name);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      id: "Housewarming",
      className: "flex mt-8 lg:mt-8 mx-auto rounded-lg bg-[#F0F0F0] lg:p-6 xl:p-8",
      children: [/*#__PURE__*/_jsx("div", {
        className: "hidden lg:inline-flex lg:w-[25%] xl:w-[20%] text-white bg-cover rounded-l-lg bg-no-repeat",
        style: {
          backgroundImage: 'url("https://cdn.loyalie.in/1713209956763_bundle%20offers")'
        },
        children: /*#__PURE__*/_jsxs("div", {
          className: "mx-auto mt-12",
          children: [giftSvg, !(config !== null && config !== void 0 && (_config$deals = config.deals) !== null && _config$deals !== void 0 && _config$deals.disableBundleDeals) && /*#__PURE__*/_jsx("h1", {
            className: "text-2xl font-medium mt-2 tracking-wider w-full lg:w-1/3",
            children: bundleOffers.length > 0 ? (_bundleOffers$2 = bundleOffers[0]) === null || _bundleOffers$2 === void 0 || (_bundleOffers$2 = _bundleOffers$2.tags[0]) === null || _bundleOffers$2 === void 0 ? void 0 : _bundleOffers$2.name.replace("House Warming", "Housewarming") : "Housewarming Gifts"
          }), (config === null || config === void 0 || (_config$deals2 = config.deals) === null || _config$deals2 === void 0 ? void 0 : _config$deals2.disableBundleDeals) && /*#__PURE__*/_jsx("h1", {
            className: "text-2xl font-medium mt-2 tracking-wider w-full lg:w-1/3",
            children: "Housewarming Gifts"
          }), /*#__PURE__*/_jsxs("button", {
            onClick: function onClick() {
              var _window5;
              if (!isAuthenticated) {
                if (dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal) {
                  dispatch(authActions.openLoginModal());
                }
                return;
              }
              (_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.webengage) === null || _window5 === void 0 || _window5.track("MakeYourOwnGiftClicked", {
                UserId: "".concat(userId)
              });
              setBundleDealModal(true);
            },
            className: "hidden lg:flex text-base lg:gap-[2px] xl:gap-1 mt-4 lg:px-3 xl:px-4 py-2 text-black rounded-lg bg-white",
            children: [BundleSvg, /*#__PURE__*/_jsx("span", {
              children: "Make Your Own Gift"
            })]
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "w-full lg:w-[75%] xl:w-[80%] ".concat(config !== null && config !== void 0 && (_config$sectionBackgr = config.sectionBackground) !== null && _config$sectionBackgr !== void 0 && _config$sectionBackgr.color ? "bg-transparent" : "lg:bg-white", " lg:rounded-r-lg"),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "p-3 md:p-5 lg:px-6 lg:py-3",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex lg:hidden justify-between items-center mb-5 cursor-pointer",
            onClick: handleViewAllBundleDeal,
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex items-center",
              children: [giftSvg, !(config !== null && config !== void 0 && (_config$deals3 = config.deals) !== null && _config$deals3 !== void 0 && _config$deals3.disableBundleDeals) && /*#__PURE__*/_jsx("h1", {
                className: "text-lg mt-2 ml-2",
                children: ((_bundleOffers$3 = bundleOffers[0]) === null || _bundleOffers$3 === void 0 || (_bundleOffers$3 = _bundleOffers$3.tags[0]) === null || _bundleOffers$3 === void 0 ? void 0 : _bundleOffers$3.name.replace("House Warming", "Housewarming")) || "Housewarming Gifts"
              }), (config === null || config === void 0 || (_config$deals4 = config.deals) === null || _config$deals4 === void 0 ? void 0 : _config$deals4.disableBundleDeals) && /*#__PURE__*/_jsx("h1", {
                className: "text-lg mt-2 ml-2",
                children: "Housewarming Gifts"
              })]
            }), /*#__PURE__*/_jsx("button", {
              className: "text-primary underline",
              onClick: handleViewAllBundleDeal,
              children: "View all"
            })]
          }), /*#__PURE__*/_jsxs("button", {
            onClick: function onClick() {
              var _window6;
              (_window6 = window) === null || _window6 === void 0 || (_window6 = _window6.webengage) === null || _window6 === void 0 || _window6.track("MakeYourOwnGiftClicked", {
                UserId: "".concat(userId)
              });
              setBundleDealModal(true);
            },
            className: "lg:hidden w-full text-base flex justify-between items-center mt-4 py-3 text-black bg-white rounded-lg border-2 border-dashed px-4",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex gap-1 md:gap-2 items-center",
              children: [BundleSvg, /*#__PURE__*/_jsx("span", {
                className: "md:text-base",
                children: "Make Your Own Gift"
              })]
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "8.73",
                height: "16.008",
                viewBox: "0 0 8.73 16.008",
                children: /*#__PURE__*/_jsx("path", {
                  id: "Right_Arrow_4_",
                  d: "M40.727,36.008a.728.728,0,0,1-.514-1.242L46.975,28l-6.762-6.762a.728.728,0,1,1,1.029-1.029l7.276,7.276a.727.727,0,0,1,0,1.029l-7.276,7.276A.725.725,0,0,1,40.727,36.008Z",
                  transform: "translate(-40 -20)",
                  fill: "#908f95"
                })
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "relative",
            children: [/*#__PURE__*/_jsx("button", {
              onClick: function onClick() {
                var container = document.getElementById("BundleOffers");
                container.scrollTo({
                  left: container.scrollLeft - 200,
                  behavior: "smooth"
                });
              },
              className: "hidden absolute -left-6 top-1/2 transform -translate-y-1/2 bg-white rounded-md py-[10px] px-[8px] z-10 lg:flex items-center justify-center shadow-md ",
              children: /*#__PURE__*/_jsx(AiOutlineLeft, {
                className: "text-black",
                size: 18
              })
            }), /*#__PURE__*/_jsx("div", {
              id: "BundleOffers",
              className: "hidden lg:flex w-full gap-4 mt-4 overflow-x-scroll overflow-x-hidden",
              children: bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.map(function (d, i) {
                return /*#__PURE__*/_jsx(DealsLayout, {
                  id: d.id,
                  title: d.title,
                  endDate: d.endDate,
                  thumbnailImageUrl: d.thumbnailImageUrl,
                  displayImageUrl: d.displayImageUrl,
                  vendorLogoUrl: d.vendorLogoUrl,
                  config: config,
                  redux: redux,
                  router: router,
                  winnreAuth: winnreAuth,
                  cmsClient: cmsClient,
                  className: "w-[180px] md:w-[210px] lg:w-[260px]"
                }, i);
              })
            }), /*#__PURE__*/_jsx("div", {
              id: "BundleOffers",
              className: " flex flex-wrap lg:hidden gap-3 md:gap-4 w-full mt-4",
              children: bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.slice(0, 4).map(function (d, i) {
                return /*#__PURE__*/_jsx(DealsLayout, {
                  id: d.id,
                  title: d.title,
                  endDate: d.endDate,
                  thumbnailImageUrl: d.thumbnailImageUrl,
                  displayImageUrl: d.displayImageUrl,
                  vendorLogoUrl: d.vendorLogoUrl,
                  config: config,
                  redux: redux,
                  router: router,
                  winnreAuth: winnreAuth,
                  cmsClient: cmsClient,
                  className: "w-[47%] md:w-[210px]"
                }, i);
              })
            }), /*#__PURE__*/_jsx("button", {
              onClick: function onClick() {
                var container = document.getElementById("BundleOffers");
                container.scrollTo({
                  left: container.scrollLeft + 200,
                  behavior: "smooth"
                });
              },
              className: " hidden absolute -right-2 top-1/2 transform -translate-y-1/2 bg-primary rounded-md py-[10px] px-[8px] z-10 lg:flex items-center justify-center ",
              children: /*#__PURE__*/_jsx(AiOutlineRight, {
                className: "text-white",
                size: 18
              })
            })]
          }), /*#__PURE__*/_jsx("button", {
            onClick: redeemAllClicked,
            className: "hidden text-center text-lg lg:flex justify-center from-yellow-400 bg-gradient-to-l to-[#FFA500] mt-4 px-8 py-2 text-white rounded-lg mx-auto",
            children: "Redeem All"
          })]
        }), /*#__PURE__*/_jsx("button", {
          onClick: redeemAllClicked,
          className: "block lg:hidden w-full text-base mt-4  py-3 text-white rounded-b-lg bg-primary font-semibold",
          children: "Redeem All"
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      visible: bundleDealModal,
      onClick: function onClick() {
        return setBundleDealModal(false);
      },
      className: "w-[90%] md:w-[55%] lg:w-[40%]",
      children: /*#__PURE__*/_jsxs("div", {
        className: "p-4",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex justify-between items-center p-2",
          children: [/*#__PURE__*/_jsx("h1", {
            className: " text-lg lg:text-2xl font-bold",
            children: "Make Your Own Gift"
          }), /*#__PURE__*/_jsx(GrClose, {
            onClick: function onClick() {
              setBundleDealModal(false);
              setSelectedOffers([]);
            },
            className: " h-5 w-5 cursor-pointer "
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "overflow-y-auto",
          children: bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.map(function (offer) {
            return /*#__PURE__*/_jsxs("div", {
              onClick: function onClick() {
                return handleCheckboxChange(offer);
              },
              className: "flex items-center gap-4 p-2 hover:bg-gray-100 rounded-md cursor-pointer",
              children: [/*#__PURE__*/_jsx("input", {
                type: "checkbox",
                className: "h-4 w-4 cursor-pointer",
                checked: selectedOffers === null || selectedOffers === void 0 ? void 0 : selectedOffers.some(function (item) {
                  return (item === null || item === void 0 ? void 0 : item.id) === offer.id;
                })
              }), /*#__PURE__*/_jsx("img", {
                src: offer.vendorLogoUrl,
                alt: offer.title,
                className: "h-12 w-12 object-contain"
              }), /*#__PURE__*/_jsx("span", {
                className: "text-sm font-medium",
                children: offer.title
              })]
            }, offer.id);
          })
        }), /*#__PURE__*/_jsx("button", {
          onClick: redeemSelectedDeals,
          className: "mt-4 w-full bg-primary text-white py-2 rounded-md",
          children: "Redeem Selected Deals"
        })]
      })
    }), /*#__PURE__*/_jsxs(Modal, {
      visible: showModal,
      onClick: function onClick() {
        return setShowModal(false);
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-end px-4 ",
        children: /*#__PURE__*/_jsx(GrClose, {
          onClick: function onClick() {
            return setShowModal(false);
          },
          className: " h-5 w-5 cursor-pointer "
        })
      }), captureUserMobile && /*#__PURE__*/_jsx(PhoneNumber
      // redeemNowClickedHandler={(mobile) =>
      //     redeemAllClicked(mobile)
      // }
      , {
        redeemNowClickedHandler: function redeemNowClickedHandler(mobile) {
          if (selectedOffers.length > 0) {
            redeemSelectedDeals(mobile);
          } else {
            redeemAllClicked(mobile);
          }
        },
        setCaptureUserMobile: setCaptureUserMobile,
        redux: redux,
        winnreAuth: winnreAuth
      }), !captureUserMobile && /*#__PURE__*/_jsx("div", {
        className: "py-3 px-4 flex flex-col",
        children: step == "0" ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("p", {
            className: "font-semibold",
            children: ["By clicking on", " ", (previousSelectedOffers === null || previousSelectedOffers === void 0 ? void 0 : previousSelectedOffers.length) > 0 ? "Redeem selected deal" : "Redeem All", ", you agree & authorize Reloy and all partner brands part of this bundle deal to call you or contact you via various communication modes to assist you with your queries. This consent will override your DNC/NDNC registration if any."]
          }), /*#__PURE__*/_jsx("div", {
            className: "flex justify-end mt-4 ",
            children: /*#__PURE__*/_jsx("button", {
              onClick: redeemAllBundleOffers,
              className: "bg-[#154F9D1A] text-[#15509E] py-2 px-7 rounded",
              children: bundleLoading && showModal ? "Loading..." : "Agree"
            })
          })]
        }) : /*#__PURE__*/_jsxs("div", {
          className: "p-4 flex flex-col items-center justify-center",
          children: [/*#__PURE__*/_jsx("div", {
            className: " rounded-full mb-5 bg-green-500 p-2 md:p-4",
            children: /*#__PURE__*/_jsx(TiTick, {
              className: " text-white h-7 w-7 md:h-8 md:w-8"
            })
          }), /*#__PURE__*/_jsxs("h1", {
            className: "text-center",
            children: ["Thank you for redeeming the exciting offers part of this Housewarming Kit. You will be communicated the steps to redeem shortly.", " "]
          })]
        })
      })]
    })]
  });
}
export default BundleOffers;